/**
 * Build-target configuration.
 *
 * Determines which app shell the React bundle behaves as.
 * Set at build time via the REACT_APP_BUILD_TARGET env var:
 *
 *   web       → full website (default; unchanged production behaviour)
 *   customer  → Customer mobile app — only customer-facing routes
 *   driver    → Driver mobile app — only driver-facing routes
 *
 * Same React codebase, three deployments:
 *   yarn build              → web bundle (transportanything247.com)
 *   yarn build:customer     → wraps into com.transport247.customer (iOS+Android)
 *   yarn build:driver       → wraps into com.transport247.driver (iOS+Android)
 *
 * The backend (REACT_APP_BACKEND_URL), auth (JWT), Stripe, dispatch, and
 * MongoDB are identical across all three targets.
 */

export const BUILD_TARGET = (process.env.REACT_APP_BUILD_TARGET || "web").toLowerCase();

export const IS_WEB = BUILD_TARGET === "web";
export const IS_CUSTOMER_APP = BUILD_TARGET === "customer";
export const IS_DRIVER_APP = BUILD_TARGET === "driver";

// Landing route for each target (when a deep link is missing or user lands on '/')
export const TARGET_HOME_ROUTE = IS_DRIVER_APP
  ? "/driver/login"
  : IS_CUSTOMER_APP
  ? "/"           // Customer app keeps the booking flow as home
  : "/";

// Display names
export const TARGET_APP_NAME = IS_DRIVER_APP
  ? "Transport 247 Driver"
  : IS_CUSTOMER_APP
  ? "Transport Anything 247"
  : "Transport | Anything, Anywhere in the UK";

// Allow the cross-portal switcher only on the full web build
export const SHOW_PORTAL_SWITCHER = IS_WEB;

// Show admin panel only on web
export const ENABLE_ADMIN_ROUTE = IS_WEB;

// SEO landing pages only on web (customer/driver apps don't need them)
export const ENABLE_SEO_PAGES = IS_WEB;

export default {
  BUILD_TARGET,
  IS_WEB,
  IS_CUSTOMER_APP,
  IS_DRIVER_APP,
  TARGET_HOME_ROUTE,
  TARGET_APP_NAME,
  SHOW_PORTAL_SWITCHER,
  ENABLE_ADMIN_ROUTE,
  ENABLE_SEO_PAGES,
};
